import clsx from 'clsx';
import * as React from 'react';
import pages from '../../data/page';
import { useSession } from '../hooks/useSession';
import { Session } from '../services/Store';

export default function AppHeader() {
    const { page: currentPage = 'start' } = useSession();

    function toggleMenu() {
        document.body.classList.toggle('menu-open');
    }

    function handlePage(page: keyof typeof pages) {
        Session.setPage(page);
    }

    return (
        <header className="header">
            <div className="header__menu-toggle" onClick={toggleMenu}>
                <div className="toggle">
                    <div className="toggle__bar" />
                </div>
            </div>
            <div className="header__menu">
                {Object.keys(pages)
                    .filter((key) => key !== 'importExport')
                    .map((page) => (
                        <button
                            key={page}
                            className={clsx('header__button', {
                                isActive: page === currentPage,
                            })}
                            onClick={() =>
                                handlePage(page as keyof typeof pages)
                            }
                        >
                            {page}
                        </button>
                    ))}
            </div>
        </header>
    );
}
